import { render, staticRenderFns } from "./d-follow-tip.vue?vue&type=template&id=15ac4dd1&scoped=true&"
import script from "./d-follow-tip.vue?vue&type=script&lang=js&"
export * from "./d-follow-tip.vue?vue&type=script&lang=js&"
import style0 from "./d-follow-tip.vue?vue&type=style&index=0&id=15ac4dd1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ac4dd1",
  null
  
)

export default component.exports